import React from 'react'

export default function DonaQRCodeTestGenerate() {
  return (
    <div>DonaQRCodeTestGenerate</div>
  )
}
